import React__default from 'react';
import { KeyboardEventKey } from '../constants.js';

var useEscapePress = function useEscapePress(callback) {
  var handleKeydown = React__default.useCallback(function (event) {
    if (event.key === KeyboardEventKey.ESC) {
      callback(event);
    }
  }, [callback]);
  React__default.useEffect(function () {
    document.documentElement.addEventListener('keydown', handleKeydown, true);
    return function () {
      document.documentElement.removeEventListener('keydown', handleKeydown, true);
    };
  }, [handleKeydown]);
};

export { useEscapePress };
